module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_9.e04882b5.png";